import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import { DataTable } from "primereact/datatable";
import { Form } from "react-bootstrap";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import filter from "../../assets/images/filter.svg";
import blueFilter from "../../assets/images/BlueFilterIcon.svg";
import "../Projects/MyProjects/index.scss";
import DsbpCommonPopup from "./DsbpCommonPopup";
import DsbpRejectDialog from "./RejectDialog";
import DsbpActionDialog from "./DsbpActionDialog";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ArtWorkTabValuesAction } from "../../../src/store/actions/ArtWorkTabValuesActions";
import { getDropDownValues } from "../../apis/getDropDownValues";
import { AWM_Biocide, AWM_AISE, AWM_Sellable } from "../ACP/constant";
import AlertIcon from "../common/AlertIcon/AlertIcon";
import { dsbpConstant } from "./constant";
import { checkIfRedIcon, checkIfGreyIcon, updateTableData } from "./utils";
import { dropDownValuesAction } from "../../store/actions/dropDownValuesAction";
import { setColumnsOrder, getColumnsOrder } from "../../apis/commonApi";

import "./AgilityList.scss";
import CommonAutocomplete from "../../Utils/CommonAutocomplete";
import ACPFilter from "../ACP/common/ACPFilter";
import CICInfo from "../../assets/images/CICInfo.svg";
import { Tooltip } from "primereact/tooltip";
import _, { cloneDeep, isArray, debounce, isObject } from "lodash";
import CustomInput from "../common/CustomInput";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../common/NavigationPrompt";
import { AcpService } from "../../service/ACPService";
import { localWidthStorage } from "../../utils";
import { CharacterLimit } from "../common/CharacterLimit/CharacterLimit";

const AgilityList = ({
  accessType = "Write",
  selected,
  dsbpPmpData,
  setSelected,
  selectAllChecked,
  handleSelect,
  handleSelectAll,
  onSort,
  selectedFields,
  onGlobalFilterChange,
  filteredDsbpData,
  setDsbpPmpData,
  onActionSubmit,
  buWiseSortedColumnNames,
  handleTabPanel,
  tabPanel,
  setFieldUpdated,
  fieldUpdated,
  setSavedData,
  addSavedData,
  handleYesAddToPRoject,
  setHandleYesAddToPRoject,
  rejectDialog,
  setRejectDialog,
  tableRender,
  setTableRender,
  customizeViewFields,
  setCustomizeViewFields,
  clearColumnWiseFilter,
  selectedReason,
  setSelectedReason,
  projectData,
  ownerList,
  ownerMatch,
  setResizeMode,
  resizeMode,
  sortData,
  setSortData,
  saveSettings,
  selectedColumnName,
  setSelectedColumnName,
  setFilteredDsbpData,
  setPageEdited,
  Assignee,
  pageEdited,
  isProjectComplete = false,
  isSelectAllDisabled = false,
  initdsbpPmpData,
  resetKey,
  resetCustomInputs,
  setResetCustomInputs,
  selectedFieldsRef,
  Status,
  setEditingInProgress,
  ArtworkStatusWrapFreeText,
  setArtworkStatusWrapFreeText
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { ProjectID } = useParams();

  const { artWorkTabValuesData } = useSelector((state) => state.ArtWorkTabValuesReducer);
  const { userInformation } = useSelector((state) => state.UserReducer);

  const currentUrl = location.pathname.split("/");
  // const accessSecurityMatrix = projectData?.Assignee === userInformation?.userid;
  const accessSecurityMatrix = (accessType === "Write" ? true : false)&&(Status==="Awaiting"?false:true);
  const op = useRef(null);

  const [tempField, setTempField] = useState("");
  const [actionType, setActionType] = useState("");
  const [tempOption, setTempOption] = useState({});
  const [showWarningDialog, setShowWarningDialog] = useState(false);
  const [onChangeData, setOnChangeData] = useState(false);
  const [rejectFormData, setRejectFormData] = useState({});
  const [addedDataForSave, setAddedDataForSave] = useState([]);
  const [mismatchedOwnerRows, setMismatchedOwnerRows] = useState([]);
  const [width, setWidth] = useState(0);
  const [copyDsbpPmpData, setCopyDsbpPmpData] = useState(cloneDeep(dsbpPmpData));
  const [isDragging, setIsDragging] = useState(false);
  const [datatableColumnFromPega, setDatatableColumnFromPega] = useState([]);
  const dragStartXRef = useRef(0); // Use useRef for dragStartX
  const [arrowPosition, setArrowPosition] = useState("left"); // Default arrow position
  const [frozenCoulmns, setFrozenCoulmns] = useState([]);

  // Pagination state and options
  const [currentRows, setCurrentRows] = useState(20);
  const totalRecords = (filteredDsbpData && filteredDsbpData.length) || (dsbpPmpData && dsbpPmpData.length) || 0;

  const rowsPerPageOptions = useMemo(() => {
    return [
      { label: 20, value: 20 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
      { label: 200, value: 200 },
      { label: "All", value: totalRecords },
    ];
  }, [totalRecords]);

  const paginatorTemplate = {
    layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
    RowsPerPageDropdown: (options) => {
      const handleRowsChange = (e) => {
        setCurrentRows(e.value);
        options.onChange(e);
      };

      return (
        <Dropdown
          value={options.value}
          options={rowsPerPageOptions}
          optionLabel="label"
          onChange={handleRowsChange}
          appendTo={document.body}
        />
      );
    },
    CurrentPageReport: (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: 'auto', textAlign: 'center' }}>
          Showing {options.first} to {options.last} of {options.totalRecords} entries
        </span>
      );
    }
  };

  const actionNameObject = [
    {
      value: "Mass Update",
      key: "option-1",
      header: "Mass Update",
    },
    {
      value: "Create POAA",
      key: "option-2",
      header: "Are you sure you want to create POAs for below PMPs in RTA ?",
    },
    {
      value: "Group PMPs",
      key: "option-3",
      header: "Are you sure you want to group these PMPs ?",
    },
    {
      value: "Add to Project",
      key: "option-4",
      header: "Are you sure you want to add these PMP to Project ?",
    },
  ];
  const [tabsList, setTabsList] = useState([
    { tabHeader: "Header 1", decription: "Header 1 data", projectId: "Project Id" },
  ]);

  const allBUAttributesData = useSelector((state) => state.DropDownValuesReducer);
  const allBUAttributes = allBUAttributesData.DropDownValuesData;
  const aiseList = useMemo(() => allBUAttributes?.ArtworkAgilityTasksPage?.Artwork_Alignment?.AISE || [], [allBUAttributes]);
  const assemblyMechanismList = useMemo(() => allBUAttributes?.ArtworkAgilityTasksPage?.Artwork_Alignment?.Assembly_Mechanism || [], [allBUAttributes]);

  const optionsList = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ];

  const addToProjectList = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
    { name: "Reject", code: "Reject" },
  ];

  const addToProjectListYes = [{ name: "Yes", code: "Yes" }];

  const BU = projectData?.BU;
  // check whether project is from home care or baby care
  let isBUHomeCare = false;
  if (BU === "Home Care") {
    isBUHomeCare = true;
  }

  useEffect(() => {
    const fetchColumnFromPega = async () => {
      try {
        if (
          projectData?.BU != null &&
          projectData?.Region != null &&
          projectData?.BU !== "" &&
          projectData?.Region !== ""
        ) {
          let datatableColumnFromPegaRes = await getColumnsOrder(
            userInformation?.userid,
            "artworkAlignmentAllColumns",
            projectData?.BU,
            projectData?.Region
          );
          if (datatableColumnFromPegaRes != null && datatableColumnFromPegaRes?.length > 0) {
            setDatatableColumnFromPega(datatableColumnFromPegaRes);
          } else {
            const jsonColumnWidth = isBUHomeCare
              ? localStorage.getItem("columnWidthDSBPArtworkHomeCare")
              : localStorage.getItem("columnWidthDSBPArtworkBabyCare");
            let allColumns = JSON.parse(jsonColumnWidth);
            setDatatableColumnFromPega(allColumns);
          }
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchColumnFromPega();
  }, []);
  const dropdownRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      if (dropdownRef?.current) {
        setWidth(dropdownRef?.current?.offsetWidth);
      }
    }, 1000);
  }, []);
  useEffect(() => {
    //setCustomizeViewFields(customizeViewFields);
    let jsonValue;
    if (
      customizeViewFields !== undefined &&
      customizeViewFields?.length !== 0 &&
      customizeViewFields !== null
    ) {
      jsonValue =
        typeof customizeViewFields === "string"
          ? JSON.parse(customizeViewFields)
          : customizeViewFields;
    }
    if (jsonValue && Object.keys(jsonValue).length !== 0) {
      let selectedData = jsonValue?.selectedFields?.fieldsData || [];
      let freezedData = jsonValue?.freezedColumns?.fieldsData || [];

      const totalColumns = [...freezedData, ...selectedData];
      setFrozenCoulmns(freezedData);
      if (totalColumns.length < 7) {
        setResizeMode("fit");
      } else {
        setResizeMode("expand");
      }
    } else{
      //Added to remove frozen icon color
      setFrozenCoulmns([]);
    }
  }, [customizeViewFields]);

  useEffect(() => {
    setSelectedColumnName("");
  }, [dsbpPmpData]);

  useEffect(() => {
    if (allBUAttributes === null) {
      (async () => {
        const allDropDown = await getDropDownValues();
        dispatch(dropDownValuesAction(allDropDown));
      })();
    }
  }, [allBUAttributes]);

  const onchangeAddToProject = (rowData, e, ele, i, removeUpdate, InitialValue) => {
    // setOnChangeData(rowData);
    // if (e.target.value === "Reject") setRejectDialog(true);
    // setRejectFormData({});
    // if (e.target.value === "Yes") setHandleYesAddToPRoject(true);
    // if (e.target.value === "No") {
    //   // updating page edited as true if page is being altered
    //   // setPageEdited(true);
    //   onChangeSelectField(rowData, e, ele);
    // }

    setOnChangeData(rowData);
    if (isObject(InitialValue) && e.target.value === "Reject") {
      //InitiaValue will be object in case any PMP is already Reject
      onChangeSelectField(rowData, e, ele, i, removeUpdate, InitialValue);
      onChangeSelectField(
        rowData,
        InitialValue.AWM_ReasonforRejection,
        "AWM_ReasonforRejection",
        i,
        removeUpdate,
        InitialValue
      );
      onChangeSelectField(
        rowData,
        InitialValue.AWM_RejectionNotes,
        "AWM_RejectionNotes",
        i,
        removeUpdate,
        InitialValue
      );
    } else if (InitialValue === e.target.value) {
      onChangeSelectField(rowData, e, ele, i, removeUpdate, InitialValue);
    } else {
      if (e.target.value === "Reject") setRejectDialog(true);
      setRejectFormData({});
      // if (e.target.value === "Yes") setHandleYesAddToPRoject(true);
      if (e.target.value === "No" || e.target.value === "Yes") {
        onChangeSelectField(rowData, e, ele, i, removeUpdate, InitialValue);
        onChangeSelectField(rowData, "", "AWM_ReasonforRejection", i, removeUpdate, InitialValue);
        onChangeSelectField(rowData, "", "AWM_RejectionNotes", i, removeUpdate, InitialValue);
      }
    }
  };
  const onchangeOwner = (rowData, e, ele, index) => {
    if (!e.value || e.value === "") {
      ownerMatch(true);
      onChangeSelectField(rowData, e, ele);
      setMismatchedOwnerRows(mismatchedOwnerRows?.filter((idx) => idx !== index));
      return;
    }
    setOnChangeData(rowData);
    onChangeSelectField(rowData, e, ele);
    if (ownerList?.some((item) => item?.Person.includes(e?.value?.Person))) {
      ownerMatch(true);
      if (mismatchedOwnerRows?.includes(index)) {
        setMismatchedOwnerRows(mismatchedOwnerRows?.filter((idx) => idx !== index));
      }
    } else {
      ownerMatch(false);
      if (e.value !== "" && e.value !== null) {
        if (!mismatchedOwnerRows?.includes(index)) {
          setMismatchedOwnerRows([...mismatchedOwnerRows, index]);
        }
      } else {
        setMismatchedOwnerRows(mismatchedOwnerRows?.filter((idx) => idx !== index));
      }
    }
  };

  const projectNameOnClick = (e, options) => {
    op.current.toggle(e);
    setSelectedColumnName(options);
  };

  const concatenatedFPCStagingFormula = (data) => {
    const concatenatedData = data.reduce((result, item) => {
      for (const key in item) {
        if (result.hasOwnProperty(key)) {
          result[key] += `,${item[key]}`;
        } else {
          result[key] = item[key];
        }
      }
      return result;
    }, {});
    return concatenatedData;
  };

  const { markDirty, markClean } = useUnsavedChangesWarning();

  // this will be called on DSBP PMP PIMaterialDescription, click or its alerticon click
  // if page is not edited it will work like earlier with else block, but
  // if page is edited then we will temprorily save action data into variables and show the warning msg
  // if a user click yes then will call confirmNavigation, which will execute previous pending action
  const handlePmpClick = (options, field, type) => {
    const unsavedChanges = JSON.parse(localStorage.getItem("unsavedChanges"));
    if (pageEdited || unsavedChanges) {
      markDirty();
      setActionType(type);
      setTempField(field);
      setTempOption(options);
      setShowWarningDialog(true);
    } else {
      onHandlePmpTabView(options, field);
    }
  };

  const navigateToURL = (tempOption) => {
    
    const navigationState = {
      PIMaterialID: tempOption.DSBP_PMP_PIMaterialID,
      from: "artworkalignmentpage",
      Assignee: userInformation?.userid,
      previousUrl: location.pathname
    };
    
    navigate(`/${currentUrl[1]}/artworkAlignment/ChangeHandling/${Assignee}/${ProjectID}`, {
      state: navigationState
    });
  };
  const handleNavigate = (tempOption) => {
    if (pageEdited) {
      setActionType("navigation");
      setTempOption(tempOption);
      setShowWarningDialog(true);
    } else {
      navigateToURL(tempOption);
    }
  };

  // on confirming yes to warning this blcok will be executed
  // by using tempHandleActionClick variable value, and based on actionType value
  const confirmNavigation = () => {
    if (actionType === "internal") {
      const updatedOption = initdsbpPmpData.filter(
        (el) =>
          el?.DSBP_PMP_PIMaterialNumber === tempOption?.DSBP_PMP_PIMaterialNumber &&
          el?.DSBP_PMP_PIMaterialID === tempOption?.DSBP_PMP_PIMaterialID &&
          el?.DSBP_InitiativeID === tempOption?.DSBP_InitiativeID
      );
      onHandlePmpTabView(updatedOption?.[0], tempField);
      // onHandlePmpTabView(tempOption, tempField);
    } else if (actionType === "navigation") {
      navigateToURL(tempOption);
    } else {
      setShowWarningDialog(false);
    }
  };

  // hiding warning on cancelNavigation click
  const cancelNavigation = () => {
    setShowWarningDialog(false);
  };

  const onHandlePmpTabView = (options, field) => {
    const selectedTab = {
      tabHeader: options[field],
      description: options,
      projectId: ProjectID,
    };
    let updatedTabsList = [];
    if (tabsList.some((tab) => JSON.stringify(tab) === JSON.stringify(selectedTab))) {
      // selectedTab is already present
    } else {
      updatedTabsList = [...tabsList, selectedTab];
    }
    const filteredArtWorkTabValuesData = artWorkTabValuesData?.filter((obj) => {
      return obj?.projectId === ProjectID || obj?.projectId === "Project Id";
    });

    const newArray = Array.isArray(artWorkTabValuesData)
      ? [...updatedTabsList, ...filteredArtWorkTabValuesData]
      : updatedTabsList;

    // const uniqueArray = Array.from(
    //   new Set(newArray.map((obj) => JSON.stringify(obj)))
    // ).map(JSON.parse);

    const seenHeaders = new Set();
    const uniqueData = [];

    for (const item of newArray) {
      if (!seenHeaders.has(item.tabHeader)) {
        seenHeaders.add(item.tabHeader);
        uniqueData.push(item);
      }
    }
    const headerIndex = uniqueData.findIndex((item) => item.tabHeader === "Header 1");
    const headerObject = uniqueData[headerIndex];
    // Remove the object with "tabHeader": "Header 1" from the original array
    uniqueData.splice(headerIndex, 1);
    // Reverse the remaining data
    uniqueData.reverse();
    // Add the header object back to the beginning
    uniqueData.unshift(headerObject);
    dispatch(ArtWorkTabValuesAction(uniqueData));
    navigate(`/${currentUrl[1]}/DSBP/tab/artworkAlignment/${ProjectID}`, {
      replace: true,
    });
  };

  const onChangeSelectField = useCallback((option, e, field, i, removeUpdate, InitialValue) => {
    //if (e!=="Reject" || e!=="" && ( typeof e === "object" && !Object.keys(e).length)) return;
    // updating page edited as true if page is being altered
    // setPageEdited(true);
    const value = typeof e === "object" && Object.keys(e).length ? e?.target?.value : e;
    
    // Skip mutation for text fields during typing to prevent lag
    if (field !== "AWM_Comment" && field !== "AWM_GroupPMP") {
      option[field] = value;
    }
    
    if (field === "Owner" && value !== "") {
      option[field] = option?.Owner?.Person || "";
    }
    if (value === "" || value === null) {
      option[field] = ""; // Reset to empty value
    }
    
    // Skip re-render for text fields to avoid latency
    if (field !== "AWM_Comment" && field !== "AWM_GroupPMP") {
      setFieldUpdated(!fieldUpdated);
    }

    const foundDsbpPmpData = copyDsbpPmpData?.find(
      (ele) => ele?.DSBP_PMP_PIMaterialID === option?.DSBP_PMP_PIMaterialID
    );

    // If value didn't change, skip update
    // if (foundDsbpPmpData && foundDsbpPmpData[field] === value) return;
    if (addSavedData && addSavedData?.length) {
      // Update existing data if it exists
      addSavedData.forEach((ele) => {
        if (
          ele.DSBP_InitiativeID === option.DSBP_InitiativeID &&
          ele.DSBP_PMP_PIMaterialID === option.DSBP_PMP_PIMaterialID
        ) {
          ele[field] = value;
          if (field === "Owner") {
            ele[field] = ele?.Owner?.Person;
          }
          if (field === "AWM_AddedToProject" && value !== "Reject") {
            ele["ReasonforRejection"] = "";
            ele["RejectionComment"] = "";
          } else {
            ele["ReasonforRejection"] = option?.AWM_ReasonforRejection;
            ele["RejectionComment"] = option?.AWM_RejectionNotes;
          }
        }
        //return ele;
      });
    }
    let checkDataIsPresentOrNot = addSavedData?.filter(
      (ele) =>
        ele.DSBP_InitiativeID === option.DSBP_InitiativeID &&
        ele.DSBP_PMP_PIMaterialID === option.DSBP_PMP_PIMaterialID
    );
    if (!checkDataIsPresentOrNot.length) {
      let updatedData = {
        DSBP_InitiativeID: option?.DSBP_InitiativeID,
        DSBP_PMP_PIMaterialID: option?.DSBP_PMP_PIMaterialID,
        DSBP_PMP_PIMaterialNumber: option?.DSBP_PMP_PIMaterialNumber,
        FK_AWMProjectID: ProjectID,
        AWM_AddedToProject: option?.AWM_AddedToProject || "",
        AWM_Comment: option?.AWM_Comment || "",
        AWM_AISE: option?.AWM_AISE || "",
        AWM_AssemblyMechanism: option?.AWM_AssemblyMechanism || "",
        AWM_Biocide: option?.AWM_Biocide || "",
        AWM_GroupPMP: option?.AWM_GroupPMP || "",
        AWM_Sellable: option?.AWM_Sellable || "",
        ReasonforRejection:
          option?.AWM_AddedToProject !== "Reject" ? "" : option?.AWM_ReasonforRejection,
        RejectionComment: option?.AWM_AddedToProject !== "Reject" ? "" : option?.AWM_RejectionNotes,
        Owner: typeof option?.Owner === "object" ? option?.Owner?.Person : option?.Owner || "",
        [field]:
          field === "Owner"
            ? typeof option?.Owner === "object"
              ? option?.Owner?.Person
              : option?.Owner || ""
            : value,
        Assignee: Assignee,
        LoggedUser: userInformation?.userid,
      };
      addSavedData.push(updatedData);
    }
    // debouncefunction(addSavedData);
    // if (foundDsbpPmpData && foundDsbpPmpData[field] !== value) {
      // Skip immediate save for text fields to prevent lag
      if (field !== "AWM_Comment" && field !== "AWM_GroupPMP") {
        setSavedData([...addSavedData]);
      }
    // }
  },[copyDsbpPmpData, addSavedData, setSavedData, ProjectID, userInformation, fieldUpdated]);

  
  useEffect(()=>{
    const updatedData = addSavedData.map(({ Assignee, LoggedUser, ...rest }) => ({
      ...rest,
      FK_AWMProjectID: "",
    }));
    const finalData = updateTableData(dsbpPmpData, updatedData, "DSBP_PMP_PIMaterialID");
    if (sortData?.length) {
      const sortedDataSet = AcpService.sortDataFirstStringThenNumeric(
        finalData,
        sortData?.[0],
        sortData?.[1],
        "artworkalign"
      );
      sortedDataSet && setDsbpPmpData([...sortedDataSet]);
    } else {
      finalData && setDsbpPmpData([...finalData]);
    }
  },[addSavedData, sortData])

  useEffect(()=>{
    setTimeout(()=>{
      setEditingInProgress(false)
    },200)
  },[dsbpPmpData])

  // on call of owner change, first check weather that owner is present or not in the ownerList, then call the function
  const debouncefunction = useCallback(
    debounce((rowData, e, ele, i, removeUpdate) => {
      onChangeSelectField(rowData, e, ele, i, removeUpdate);
    }, 500),
    [onChangeSelectField]
  );

  const handleSelectOwner = useCallback((rowData, e, ele, i, removeUpdate) => {
    if (ownerList?.includes(e?.target?.value)) {
      debouncefunction(rowData, e, ele, i, removeUpdate);
    } else {
      return;
    }
  }, [ownerList, debouncefunction]);

  // Debounced handler for text inputs to reduce latency
  const debouncedTextChange = useCallback(
    debounce((rowData, e, ele, i, removeUpdate, InitialValue) => {
      const value = typeof e === "object" && Object.keys(e).length ? e?.target?.value : e;
      // Now apply the mutation after debounce
      rowData[ele] = value;
      onChangeSelectField(rowData, e, ele, i, removeUpdate, InitialValue);
      // Trigger save after debounce
      setSavedData([...addSavedData]);
    }, 300),
    [onChangeSelectField, addSavedData, setSavedData]
  );

  // const debouncefunction = useCallback(
  //   debounce((addSavedData) => {
  //     setSavedData([...addSavedData]);
  //   }, 100),
  //   [setSavedData]
  // );

  const addBody = useCallback((options, rowData) => {
    let field = rowData.field;
    // Show icons only based on ChangeHandlingIcon field
    const showRedIcon = options.ChangeHandlingIcon === "Red";
    const showGreyIcon = options.ChangeHandlingIcon === "Gray";
    const showAlertIcon = showRedIcon || showGreyIcon;
    const fieldEditable = options["AWM_AddedToProject"] === "Yes";
    const ownerEditable = options["DSBP_PMP_AWReadinessGateStatus"] === dsbpConstant.xml_locked;
    // const isOwner = options["Owner"] === userInformation?.userid;
    const addToProjectEditable =
      options["AWM_POARequested"] === "Yes" ||
      options["RTA_POANumber"] !== "" ||
      options["POAStatus"] === "Awaiting Response" ||
      options["DSBP_PMP_AWReadinessGateStatus"] !== "LOCKED" ||
      (options["RTA_POANumber"] === "" && options["AWM_CICNeeded"] === "Yes");

    // const addToProjectNotEditable =
    //   (options["AWM_POARequested"] === "Yes" && options["RTA_POANumber"] !== "") ||
    //   (options["AWM_POARequested"] === "Yes" &&
    //     options["RTA_POANumber"] == "" &&
    //     options["POAStatus"] == "Awaiting Response");
    let FPCStagingFormula = options?.FPCStagingPage?.[0]?.FormulaCardStagingPage;
    let concatenatedFPCStagingFormulaData = {};
    if (FPCStagingFormula && FPCStagingFormula.length) {
      concatenatedFPCStagingFormulaData = concatenatedFPCStagingFormula(FPCStagingFormula);
    }
    return (
      <>
        {field === "field_0" && ( // Add this condition to render a checkbox
          <div className="flex align-items-center">
            <input
              type="checkbox"
              className="p-checkbox-box p-highlight"
              checked={
                Array.isArray(selected) &&
                selected?.some(
                  (item) => item?.DSBP_PMP_PIMaterialID === options?.DSBP_PMP_PIMaterialID
                )
              }
              onChange={() => handleSelect(options)}
              // disabled={(!accessSecurityMatrix && !isOwner) || isProjectComplete}
              disabled={!accessSecurityMatrix || isProjectComplete}
            />
          </div>
        )}
        {options?.FPCStagingPage?.[0][field] && (
          <span title={options?.FPCStagingPage?.[0][field]}>
            {options?.FPCStagingPage?.[0][field]}{" "}
          </span>
        )}
        {concatenatedFPCStagingFormulaData?.[field]}
        {field === "DSBP_PMP_PIMaterialNumber" && (
          <>
            {/* When Assignee is emtpy Naviagiton should be restricted */}
            {Assignee ? (
              <a className="tabView" onClick={() => handlePmpClick(options, field, "internal")}>
                <span title={options[field]} className="text-option">
                  {options[field]}
                </span>
              </a>
            ) : (
              <span className="text-option">{options[field]}</span>
            )}
            <AlertIcon
              iconType="error"
              showAlertIcon={showAlertIcon}
              onClick={() => handleNavigate(options)} //code optimized 3043 defect
              editable={showGreyIcon}
              tooltipClass="tooltip-white"
              tooltipText={
                showGreyIcon
                  ? dsbpConstant.xml_awaiting_response_enovia
                  : dsbpConstant.xml_view_changes
              }
              tooltipPosition={"top"}
            />
          </>
        )}
        {field === "Wave_Name" && (
            <span
              title={options?.[field]}
              className="wave-name-badge"
              style={{
                color: options?.["Wave_Color_Code_TEXT"] || "black",
                backgroundColor:
                  options?.["Wave_Color_Code_BG"] || "transparent",
              }}
            >
              {options?.[field]}
            </span>
        )}

        {field === "AWM_AddedToProject" && (
          <>
            {/* <Form.Group controlId="groupName.ControlInput1" className="AddToProjectColumn">
              <Form.Select
                placeholder="Select"
                value={options[field]}
                onChange={(e) => onchangeAddToProject(options, e, field)}
                style={{ width: "80%", fontSize: 12 }}
                disabled={addToProjectEditable || !accessSecurityMatrix || isProjectComplete}
              >
                <option value="">Select</option>
                {options["AWM_POARequested"] === "Yes" && options["AWM_AWJStatus"] === "Active"
                  ? addToProjectListYes?.map((data) => (
                      <option key={data.code} value={data.name}>
                        {data.name}
                      </option>
                    ))
                  : addToProjectList?.map((data) => (
                      <option key={data.code} value={data.name}>
                        {data.name}
                      </option>
                    ))}
              </Form.Select>
              {options["RTA_POANumber"] === "" && options["AWM_CICNeeded"] === "Yes" && (
                <span>
                  <img src={CICInfo} className="cicinfoicon" alt="" />
                  <Tooltip
                    position="top"
                    target=".cicinfoicon"
                    className="tooltip-white-cic"
                    content={dsbpConstant.addToProjectDisabledMessage}
                  />
                </span>
              )}
            </Form.Group> */}

            <CustomInput
              type="Select"
              field={field}
              options={options}
              sortData={sortData}
              selected={selected}
              placeholder="Select"
              value={options[field]}
              filterData={selectedFieldsRef?.current}
              fieldType="AWM_AddedToProject"
              onChange={onchangeAddToProject}
              className={"AddToProjectColumn"}
              optionArray={
                options["AWM_POARequested"] === "Yes" && options["AWM_AWJStatus"] === "Active"
                  ? addToProjectListYes
                  : addToProjectList
              }
              controlId="groupName.ControlInput1"
              style={{ textAlign: "-webkit-center" }}
              innerStyle={{ width: "80%", fontSize: 12 }}
              innerDisabled={addToProjectEditable || !accessSecurityMatrix || isProjectComplete}
              resetCustomInputs={resetCustomInputs}
              setResetCustomInputs={setResetCustomInputs}
            />
          </>
        )}

        {field === "Owner" && (
          <>
            {/* <Form.Group controlId="groupName.ControlInput1" className="owner-field-group">
              <div className="common-owner-field" ref={dropdownRef}>
                <CommonAutocomplete
                  width={width}
                  suggestions={ownerList}
                  className="artworkOwnerField"
                  value={options[field]}
                  onChange={(e) => {
                    // onchangeOwner(options, e, field, rowData.rowIndex);
                    handleSelectOwner(options, e, field, rowData.rowIndex);
                  }}
                  placeholder="Select Shell Owner"
                  field="Person"
                  disabled={
                    !ownerEditable ||
                    !accessSecurityMatrix ||
                    options["AWM_AddedToProject"] !== "Yes" ||
                    isProjectComplete
                  }
                />
                {mismatchedOwnerRows.includes(rowData.rowIndex) && <div>No results found</div>}
              </div>
            </Form.Group> */}
            <CustomInput
              field={field}
              width={width}
              ref={dropdownRef}
              rowData={rowData}
              options={options}
              fieldType={field}
              sortData={sortData}
              value={options[field]}
              suggestions={ownerList}
              internalField={"Person"}
              onChange={handleSelectOwner}
              className="owner-field-group"
              filterData={selectedFieldsRef?.current}
              placeholder={"Select Shell Owner"}
              type="SeacrhAndSelectAutoComplete"
              controlId="groupName.ControlInput1"
              innerClassName={
                (!ownerEditable ||
                !accessSecurityMatrix || 
                options["AWM_AddedToProject"] !== "Yes" ||
                isProjectComplete) && "artworkOwnerFieldDisabled"}
              wrapperClassName="common-owner-field"
              disabled={
                !ownerEditable ||
                !accessSecurityMatrix ||
                options["AWM_AddedToProject"] !== "Yes" ||
                isProjectComplete
              }
              mismatchedOwnerRows={mismatchedOwnerRows}
              resetCustomInputs={resetCustomInputs}
              setResetCustomInputs={setResetCustomInputs}
            />
          </>
        )}

        {field === "AWM_Comment" && (
          <>
            <CustomInput
              type="text"
              field={field}
              maxLength={256}
              options={options}
              sortData={sortData}
              value={options[field]}
              fieldType="AWM_Comment"
              onChange={debouncedTextChange}
              filterData={selectedFieldsRef?.current}
              placeholder={"Enter Comment"}
              disabled={ !accessSecurityMatrix }
              resetCustomInputs={resetCustomInputs}
              setResetCustomInputs={setResetCustomInputs}
              setEditingInProgress={setEditingInProgress}
            />
            <CharacterLimit field={options[field]} maxLength={256} />
          </>
        )}

        {field === "AWM_AISE" && (
          <>
            {/* <Form.Group controlId="groupName.ControlInput1" className="AISE-field-group">
              <Form.Select
                placeholder="Select"
                value={options[field]}
                disabled={!fieldEditable || !accessSecurityMatrix || isProjectComplete}
                onChange={(e) => onChangeSelectField(options, e, field)}
                style={{ width: "80%", fontSize: 12 }}
              >
                <option value="">Select</option>
                {aiseList?.map((data) => (
                  <option key={data.AWM_AISE} value={data.AWM_AISE}>
                    {data.AWM_AISE}
                  </option>
                ))}
              </Form.Select>
            </Form.Group> */}
            <CustomInput
              type="Select"
              field={field}
              options={options}
              sortData={sortData}
              fieldType="AWM_AISE"
              placeholder="Select"
              optionArray={aiseList}
              value={options[field]}
              filterData={selectedFieldsRef?.current}
              className={"AISE-field-group"}
              onChange={onChangeSelectField}
              controlId="groupName.ControlInput1"
              innerStyle={{ width: "80%", fontSize: 12 }}
              innerDisabled={!fieldEditable || !accessSecurityMatrix || isProjectComplete}
              resetCustomInputs={resetCustomInputs}
              setResetCustomInputs={setResetCustomInputs}
            />
          </>
        )}

        {field === "AWM_AssemblyMechanism" && (
          <>
            {/* <Form.Group controlId="groupName.ControlInput1" style={{ textAlign: "-webkit-center" }}>
              <Form.Select
                placeholder="Select"
                value={options[field]}
                disabled={!fieldEditable || !accessSecurityMatrix || isProjectComplete}
                onChange={(e) => onChangeSelectField(options, e, field)}
                style={{ width: "80%", fontSize: 12 }}
              >
                <option value="">Select</option>
                {assemblyMechanismList?.map((data) => (
                  <option key={data.code} value={data.AWM_AssemblyMechanism}>
                    {data.AWM_AssemblyMechanism || options[field]}
                  </option>
                ))}
              </Form.Select>
            </Form.Group> */}
            <CustomInput
              type="Select"
              field={field}
              options={options}
              sortData={sortData}
              placeholder="Select"
              value={options[field]}
              filterData={selectedFieldsRef?.current}
              className={"AISE-field-group"}
              onChange={onChangeSelectField}
              fieldType="AWM_AssemblyMechanism"
              controlId="groupName.ControlInput1"
              optionArray={assemblyMechanismList}
              style={{ textAlign: "-webkit-center" }}
              innerStyle={{ width: "80%", fontSize: 12 }}
              innerDisabled={!fieldEditable || !accessSecurityMatrix || isProjectComplete}
              resetCustomInputs={resetCustomInputs}
              setResetCustomInputs={setResetCustomInputs}
            />
          </>
        )}

        {field === "AWM_GroupPMP" && (
          <>
            {/* <Form.Group controlId="groupName.ControlInput1" style={{ textAlign: "-webkit-center" }}>
            <Form.Control
              type="text"
              value={options[field]}
              disabled={!fieldEditable || !accessSecurityMatrix}
              onChange={(e) => onChangeSelectField(options, e, field)}
              placeholder="Enter Group Name"
            />
          </Form.Group> */}
            {/* {commented above code as this block is inside loop, 
            so inside loop we can't compare and update value, 
            it will take lot of time, so avoid time delay, 
            created a seperate Reusable component, so that 
            it could be utilize in Future As well} */}
            <CustomInput
              type="text"
              field={field}
              options={options}
              sortData={sortData}
              value={options[field]}
              fieldType="AWM_GroupPMP"
              onChange={debouncedTextChange}
              filterData={selectedFieldsRef?.current}
              placeholder={"Enter Group Name"}
              disabled={!fieldEditable || !accessSecurityMatrix || isProjectComplete}
              resetCustomInputs={resetCustomInputs}
              setResetCustomInputs={setResetCustomInputs}
              setEditingInProgress={setEditingInProgress}
            />
          </>
        )}

        {field === "AWM_Sellable" && (
          <>
            {/* <Form.Group controlId="groupName.ControlInput1" style={{ textAlign: "-webkit-center" }}>
              <Form.Select
                placeholder="Select"
                value={options[field]}
                disabled={!fieldEditable || !accessSecurityMatrix || isProjectComplete}
                onChange={(e) => onChangeSelectField(options, e, field)}
                style={{ width: "80%", fontSize: 12 }}
              >
                <option value="">Select</option>
                {optionsList?.map((data) => (
                  <option key={data.code} value={data.name}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group> */}
            <CustomInput
              type="Select"
              field={field}
              options={options}
              sortData={sortData}
              placeholder="Select"
              value={options[field]}
              fieldType="AWM_Sellable"
              optionArray={optionsList}
              filterData={selectedFieldsRef?.current}
              className={"AISE-field-group"}
              onChange={onChangeSelectField}
              controlId="groupName.ControlInput1"
              style={{ textAlign: "-webkit-center" }}
              innerStyle={{ width: "80%", fontSize: 12 }}
              innerDisabled={!fieldEditable || !accessSecurityMatrix || isProjectComplete}
              resetCustomInputs={resetCustomInputs}
              setResetCustomInputs={setResetCustomInputs}
            />
          </>
        )}

        {field === "AWM_Biocide" && (
          <>
            {/* <Form.Group controlId="groupName.ControlInput1" style={{ textAlign: "-webkit-center" }}>
              <Form.Select
                placeholder="Select"
                value={options[field]}
                disabled={!fieldEditable || !accessSecurityMatrix || isProjectComplete}
                onChange={(e) => onChangeSelectField(options, e, field)}
                style={{ width: "80%", fontSize: 12 }}
              >
                <option value="">Select</option>
                {optionsList?.map((data) => (
                  <option key={data.code} value={data.name}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group> */}
            <CustomInput
              type="Select"
              field={field}
              options={options}
              sortData={sortData}
              placeholder="Select"
              value={options[field]}
              fieldType="AWM_Biocide"
              optionArray={optionsList}
              filterData={selectedFieldsRef?.current}
              className={"AISE-field-group"}
              onChange={onChangeSelectField}
              controlId="groupName.ControlInput1"
              style={{ textAlign: "-webkit-center" }}
              innerStyle={{ width: "80%", fontSize: 12 }}
              innerDisabled={!fieldEditable || !accessSecurityMatrix || isProjectComplete}
              resetCustomInputs={resetCustomInputs}
              setResetCustomInputs={setResetCustomInputs}
            />
          </>
        )}
        {field == "RTA_POANumber" && <span>{options["RTA_POANumber"]}</span>}
        {field !== "AWM_AddedToProject" &&
          field !== "AWM_Comment" &&
          field !== "DSBP_PMP_PIMaterialNumber" &&
          field !== "AWM_AISE" &&
          field !== "AWM_AssemblyMechanism" &&
          field !== "AWM_Biocide" &&
          field !== "AWM_GroupPMP" &&
          field !== "AWM_Sellable" &&
          field !== "field_0" &&
          field !== "POA_POANumber" &&
          field !== "RTA_POANumber" &&
          field !== "POANumber" &&
          field !== "Wave_Name" &&
          field !== "Owner" && <span title={options[field]}> {options[field]} </span>}
      </>
    );
  }, [selected, ownerList, Assignee, accessSecurityMatrix, isProjectComplete, selectedFieldsRef, resetCustomInputs, setResetCustomInputs, setEditingInProgress, mismatchedOwnerRows, handleSelect, handleSelectOwner, handlePmpClick, handleNavigate, onChangeSelectField, addToProjectList, addToProjectListYes, aiseList, assemblyMechanismList, optionsList, dsbpConstant, sortData, width, dropdownRef]);

  const renderHeader = (field, col) => {

    // let isFilterActivated =
    //   col?.freeze === true || col?.sortAtoZ === true || col?.sortZtoA === true;
    if (field === "checkbox") {
      // Render checkbox in header
      return (
        <div className="flex align-items-center">
          {/* 3190 changes and arrow left and right direction */}
          {isDragging && (
            <div
              className={`drag-arrow ${arrowPosition === "left" ? "left-arrow" : "right-arrow"}`}
            >
              {arrowPosition === "left" ? "←" : "→"}
            </div>
          )}
          <input
            type="checkbox"
            className="p-checkbox-box p-highlight"
            checked={selectAllChecked}
            disabled={
              dsbpPmpData === null ||
              !dsbpPmpData?.length ||
              isSelectAllDisabled ||
              !accessSecurityMatrix ||
              isProjectComplete
            }
            onChange={handleSelectAll}
          />
        </div>
      );
    }
    let splittedCol = col?.Column_Name?.split("_").join(" ");
    // splittedCol= splittedCol ==="Owner" ? "Shell Creation Owner":splittedCol;
    return (
      <div className={`flex-display ${col.freeze ? "font-bold frozen-width" : ""}`} key={field}>
        <img
          src={
            selectedFields?.[field]?.[0] || selectedFields?.[field]?.[0] == false
              ? blueFilter
              : filter
          }
          key={field}
          alt="Column Filter"
          onClick={(e) => projectNameOnClick(e, field)}
          className="columnFilterIcon"
        />
        <span className="columnFilterIcon"> {splittedCol}</span>
      </div>
    );
  };

  const columns = useMemo(() => {
    let jsonColumnWidth = isBUHomeCare
      ? localStorage.getItem("columnWidthDSBPArtworkHomeCare")
      : localStorage.getItem("columnWidthDSBPArtworkBabyCare");
    const localColumnWidth = localStorage.getItem("columnWidthartworkAlignment");
    let columnWidth = {};
    if (localColumnWidth) {
      columnWidth = JSON.parse(localColumnWidth);
    }
    const columnWidthKeys = Object.keys(columnWidth);
    let allColumns = JSON.parse(jsonColumnWidth); //datatableColumnFromPega
    // customize fields
    let jsonValue;

    if (
      customizeViewFields !== undefined &&
      customizeViewFields?.length !== 0 &&
      customizeViewFields !== null
    ) {
      jsonValue =
        typeof customizeViewFields === "string"
          ? JSON.parse(customizeViewFields)
          : customizeViewFields;
    }
    if (jsonValue && Object.keys(jsonValue).length !== 0) {
      let selectedData = jsonValue?.selectedFields?.fieldsData || [];
      let freezedData = jsonValue?.freezedColumns?.fieldsData || [];
      const filteredColumns = [];
      // Add freezedData columns in the specified order
      freezedData?.forEach((fieldName, index) => {
        const column = allColumns?.find((col) => col.Field_Name === fieldName);
        if (column) {
          column.freeze = true;
          filteredColumns.push(column);
        } else {
          let newColumn = {};
          newColumn.Sequence = index;
          newColumn.Attribute_Type = "Free Text";
          newColumn.Column_Name = fieldName;
          newColumn.Field_Name = fieldName;
          newColumn.freeze = true;
          newColumn.reorder = false;
          newColumn.sortAtoZ = false;
          newColumn.sortZtoA = false;
          newColumn.width = 250;
          newColumn.customizeViewField = true;
          filteredColumns.push(newColumn);
        }
      });
      // Add selectedData columns in the specified order
      selectedData?.forEach((fieldName, index) => {
        const column = allColumns?.find((col) => col.Field_Name === fieldName);
        if (column) {
          filteredColumns.push(column);
        } else {
          let newColumn = {};
          newColumn.Sequence = index.toString();
          newColumn.Attribute_Type = "Free Text";
          newColumn.Column_Name = fieldName;
          newColumn.Field_Name = fieldName;
          newColumn.freeze = false;
          newColumn.reorder = false;
          newColumn.sortAtoZ = false;
          newColumn.sortZtoA = false;
          newColumn.width = 250;
          newColumn.customizeViewField = true;
          filteredColumns.push(newColumn);
        }
      });
      if (filteredColumns?.length > allColumns?.length) { 
        isBUHomeCare
          ? localStorage.setItem("columnWidthDSBPArtworkHomeCare", JSON.stringify(filteredColumns))
          : localStorage.setItem("columnWidthDSBPArtworkBabyCare", JSON.stringify(filteredColumns));
      }
      if (filteredColumns && filteredColumns.length) {
        return [
          // Checkbox column
          <Column
            key="checkbox"
            body={addBody}
            frozen={true}
            columnKey="checkbox"
            header={() => renderHeader("checkbox")}
            className="checkbox-column"
            headerClassName="checkbox-width"
            bodyClassName="checkbox-width"
          />,
          // Rest of the columns
          ...filteredColumns.map((field, index) => {
            //if its not home care and BU is baby care restricted these columns
            if (
              !isBUHomeCare &&
              (field.Field_Name === AWM_Biocide ||
                field.Field_Name === AWM_AISE ||
                field.Field_Name === AWM_Sellable)
            ) {
              return null;
            }
            return (
              <Column
                field={field.Field_Name}
                header={() => renderHeader(field.Field_Name, field)}
                frozen={field.freeze}
                headerClassName={field.freeze ? "font-bold frozen-width" : ""}
                className={field.freeze ? "font-bold frozen-width" : ""}
                body={addBody}
                key={field.Field_Name}
                columnKey={field.Field_Name}
                showFilterMenu={false}
                alignFrozen="left"
                filterField={field.Field_Name}
                style={{
                  width:
                    columnWidthKeys.includes(field.Field_Name) &&
                    columnWidth &&
                    columnWidth[field.Field_Name],
                  maxWidth:
                    columnWidthKeys.includes(field.Field_Name) &&
                    columnWidth &&
                    columnWidth[field.Field_Name],
                    
                whiteSpace: 'normal ',
                wordBreak: 'break-word',
                }}
              />
            );
          }),
        ];
      }
    } else {
      const upatingData = allColumns?.filter((data) => !data.customizeViewField);
      if (upatingData) {
        isBUHomeCare
          ? localStorage.setItem("columnWidthDSBPArtworkHomeCare", JSON.stringify(upatingData))
          : localStorage.setItem("columnWidthDSBPArtworkBabyCare", JSON.stringify(upatingData));
      }
      const upatingDataAllColumns = upatingData ? upatingData : allColumns;
      if (upatingDataAllColumns && upatingDataAllColumns.length) {
        return [
          // Checkbox column
          <Column
            key="checkbox"
            body={addBody}
            frozen={true}
            columnKey="checkbox"
            className="checkbox-column"
            header={() => renderHeader("checkbox")}
            headerClassName="checkbox-width"
            bodyClassName="checkbox-width"
          />,
          // Rest of the columns
          ...upatingDataAllColumns.map((field, index) => {
            //if its not home care and BU is baby care restricted these columns
            if (
              !isBUHomeCare &&
              (field.Field_Name === AWM_Biocide ||
                field.Field_Name === AWM_AISE ||
                field.Field_Name === AWM_Sellable)
            ) {
              return null;
            }
            return (
              <Column
                field={field.Field_Name}
                header={() => renderHeader(field.Field_Name, field)}
                frozen={field.freeze}
                body={addBody}
                key={field.Field_Name}
                columnKey={field.Field_Name}
                showFilterMenu={false}
                alignFrozen="left"
                filterField={field.Field_Name}
                headerClassName={field.freeze ? "font-bold " : ""}
                style={{
                  width:
                    columnWidthKeys.includes(field.Field_Name) &&
                    columnWidth &&
                    columnWidth[field.Field_Name],
                  maxWidth:
                    columnWidthKeys.includes(field.Field_Name) &&
                    columnWidth &&
                    columnWidth[field.Field_Name],
                    whiteSpace: ArtworkStatusWrapFreeText ? 'normal' : 'nowrap',
                    wordBreak: ArtworkStatusWrapFreeText ? 'break-word': 'unset',
                    overflow: ArtworkStatusWrapFreeText ? 'unset' : 'hidden',
                    textOverflow: ArtworkStatusWrapFreeText ? 'unset' : 'ellipsis',
                }}
              />
            );
          }),
        ];
      }
    }
    return [];
  // dependencies below ensure columns recompute only when these significant inputs change
  }, [customizeViewFields, isBUHomeCare, ArtworkStatusWrapFreeText, fieldUpdated, tableRender, addBody]);

  const onColumnResizeEnd = (event) => {
    let columnWidth = [];
    let jsonColumnWidth = isBUHomeCare
      ? localStorage.getItem("columnWidthDSBPArtworkHomeCare")
      : localStorage.getItem("columnWidthDSBPArtworkBabyCare");
    if (jsonColumnWidth) {
      columnWidth = JSON.parse(jsonColumnWidth);
    }
    if (columnWidth) {
      columnWidth.map((list) => {
        if (event.column.props.field === list.Field_Name) {
          list.width = event.element.offsetWidth;
        }
      });
    }
    localWidthStorage(event, "columnWidthartworkAlignment");
    // localStorage.setItem("columnWidthDSBPArtwork", JSON.stringify(columnWidth));

    isBUHomeCare
      ? localStorage.setItem("columnWidthDSBPArtworkHomeCare", JSON.stringify(columnWidth))
      : localStorage.setItem("columnWidthDSBPArtworkBabyCare", JSON.stringify(columnWidth));
    setFieldUpdated(!fieldUpdated);
    setTableRender(false);
  };

  //AWM-3190 Function to handle the start of a drag event
  const onDragStart = useCallback((event) => {
    dragStartXRef.current = event.clientX || event.pageX; // Capture initial drag position
    setIsDragging(true); // Enable dragging
  }, []);

  const onDrag = useCallback((event) => {
    if (isDragging) {
      const currentX = event.clientX || event.pageX; // Get current drag position
      setArrowPosition((prev) => {
        if (currentX > dragStartXRef.current && prev !== "right") return "right";
        if (currentX < dragStartXRef.current && prev !== "left") return "left";
        return prev;
      });
    }
  }, [isDragging]);

  const onDragEnd = useCallback(() => {
    setIsDragging(false); // Disable dragging
    dragStartXRef.current = 0; // Reset drag start position
  }, []);

  const storeReorderedColumns = (e) => {
    let columnNames = [];
    // let jsonColumnNames = localStorage.getItem("columnWidthDSBPArtwork");
    let jsonColumnNames = isBUHomeCare
      ? localStorage.getItem("columnWidthDSBPArtworkHomeCare")
      : localStorage.getItem("columnWidthDSBPArtworkBabyCare");
    if (jsonColumnNames) {
      columnNames = JSON.parse(jsonColumnNames);
    }
    const shiftedArray = [...columnNames]; // Create a copy of the array
    // Find the index of the element to be shifted
    if (e?.dragIndex !== -1) {
      const [removed] = shiftedArray.splice(e?.dragIndex, 1); // Remove the element from the array
      // shiftedArray.unshift(removed); // Place the removed element at the beginning of the array
      shiftedArray.splice(e?.dropIndex, 0, removed);
    }
    shiftedArray.map((ele, index) => {
      ele["Sequence"] = index;
      ele["reorder"] = true;
    });

    // isBUHomeCare
    //   ? localStorage.setItem("columnWidthDSBPArtworkHomeCare", JSON.stringify(shiftedArray))
    //   : localStorage.setItem("columnWidthDSBPArtworkBabyCare", JSON.stringify(shiftedArray));
    // localStorage.setItem(
    //   "columnWidthDSBPArtwork",
    //   JSON.stringify(shiftedArray)
    // );
    setFieldUpdated(!fieldUpdated);
    setTableRender(false);
  };

  const rowClassName = useCallback((rowData) => (selected?.some(item=>item?.DSBP_PMP_PIMaterialID===rowData[0]?.DSBP_PMP_PIMaterialID) ? "selected-row" : ""), [selected]);

  return (
    <>
      <DataTable
        dataKey="DSBP_PMP_PIMaterialID"
        key={tableRender ? `"DSBP_PMP_PIMaterialID" + timestamp${resetKey}` : resetKey}
        scrollable
        resizableColumns
        reorderableColumns
        onColumnResizeEnd={onColumnResizeEnd}
        onColReorder={storeReorderedColumns}
        columnResizeMode={resizeMode}
        responsiveLayout="scroll"
        value={filteredDsbpData && filteredDsbpData.length ? filteredDsbpData : dsbpPmpData}
        className="mt-3" 
        selection={selected}
        onSelectionChange={(e) => setSelected(e.value)}
        paginator={dsbpPmpData?.length > 20 || filteredDsbpData?.length > 20}
        paginatorPosition="bottom"
        paginatorTemplate={paginatorTemplate}
        rows={currentRows}
        rowClassName={rowClassName}
        onDragStart={onDragStart}
        onDrag={onDrag} // Add onDrag to track the drag movement
        onDragEnd={onDragEnd}
        tableStyle={{
          width: "max-content",
          minWidth: "100%",
        }}
      >
        {columns} 
      </DataTable>
      <ACPFilter
        op={op}
        onSort={onSort}
        sortData={sortData}
        setSortData={setSortData}
        saveSettings={saveSettings}
        pageName={"artworkAlignment"}
        selectedFields={selectedFields}
        selectAllColumnNotIncluded={true}
        projectData={dsbpPmpData}
        selectedColumnName={selectedColumnName}
        filters={filteredDsbpData}
        onGlobalFilterChange={onGlobalFilterChange}
        setFilters={setFilteredDsbpData}
        clearColumnWiseFilter={clearColumnWiseFilter}
        frozenCoulmns={[]}
      />
      {rejectDialog && (
        <DsbpCommonPopup
          actionHeader="Are you sure you want to reject this PMP?"
          dasbpDialog={rejectDialog}
          setDasbpDialog={setRejectDialog}
          rejectFormData={rejectFormData}
          // onSubmit={() => onActionSubmit(rejectFormData, [onChangeData])}
          onSubmit={() => {
            setRejectDialog(false);
            onChangeData.AWM_AddedToProject = "Reject";
            onChangeData.AWM_ReasonforRejection = rejectFormData?.ReasonforRejection;
            onChangeData.AWM_RejectionNotes = rejectFormData?.RejectionComment;
            onChangeSelectField(
              onChangeData,
              "Reject",
              "AWM_AddedToProject",
              undefined,
              false,
              undefined
            );
          }}
          okButtonShow={false}
          deleteButtonShow={false}
          showCancel={false}
          submitButtonShow={true}
          yesButtonShow={false}
          disconnectButtonShow={true}
          selectedReason={selectedReason}
          setSelectedReason={setSelectedReason}
        >
          <DsbpRejectDialog
            onChangeData={onChangeData}
            rejectFormData={rejectFormData}
            setRejectFormData={setRejectFormData}
            setSelectedReason={setSelectedReason}
          />
        </DsbpCommonPopup>
      )}
      {handleYesAddToPRoject && (
        <DsbpActionDialog
          actionHeader="Are you sure you want to add these PMP to Project ?"
          actionDialog={handleYesAddToPRoject}
          setActionDialog={setHandleYesAddToPRoject}
          onChangeData={onChangeData}
          rowData={onChangeData}
          onActionSubmit={onActionSubmit}
          ownersList={ownerList}
          actionNameObject={actionNameObject}
        />
      )}
      {/* this block is being used to show warning on same page header page */}
      <UnsavedChangesDialog
        visible={showWarningDialog}
        onConfirm={() => {
          // on confirming loss of change, page edited flag is set to false
          setPageEdited(false);

          confirmNavigation();
        }}
        onCancel={cancelNavigation}
      />
    </>
  );
};

export default React.memo(AgilityList);
